import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_DETAILS_SHARE_CTA_PLACEMENT = defineFcm('petition_details_share_cta_placement')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Mobile Action Button',
		description:
			'Kill switch for the 4-arm (control, fake_control, v1, v2) share CTA placement experiment on the petition details page mobile action button, independent of Experiment Service assignment.\n\nhttps://change.atlassian.net/browse/CHANGE-94948',
		template: {
			enabled: true,
		},
		import: false,
	});
